import { HLHLContactRole } from "./hlhl-contacts";

export type ClaimTypes = "standard" | "onetime";
export type UserTypes = "borrower" | "operator";
export enum Role {
  Admin = "admin",
  Borrower = "borrower",
  CanViewRestricted = "restricted",
  CapitalMarkets = "capital_markets",
  CashClose = "cash_close",
  CashCloseAdmin = "cash_close_admin",
  LoanOfficer = "loan_officer",
  OpsAdmin = "ops_admin",
  SettlementAgent = "settlement_agent",
  Underwriter = "underwriter",
}

export const ResourceToRoles = {
  "capital-markets": [Role.Admin, Role.CapitalMarkets],
  "loan-officer": [Role.Admin, Role.LoanOfficer],
  reporting: [
    Role.Admin,
    Role.CapitalMarkets,
    Role.Underwriter,
    Role.CashClose,
    Role.CashCloseAdmin,
  ],
  "settlement-agent": [Role.Admin, Role.SettlementAgent],
  underwriter: [Role.Admin, Role.Underwriter],
  tools: [Role.Admin, Role.CashCloseAdmin, Role.Underwriter],
};

export interface Claims {
  exp: number;
  operator_id: number;
  roles: [Role];
  hlhl_contact_role: HLHLContactRole;
  type: ClaimTypes;
  user_id: number;
  user_type: UserTypes;
}
